import './link-button.css';
import { Card, Paragraph } from '@digdir/designsystemet-react';
import { useState } from 'react';

export interface LinkButtonContent {
	title?: string;
	icon?: string;
	hoverIcon?: string;
	link?: string;
}

const LinkButton = ({ content, index }) => {
	const [isHovered, setIsHovered] = useState(false);

	const iconUrl = content.icon;
	const hoverUrl = content.hoverIcon;

	return (
		<Card
			asChild
			key={index}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<a href={content.link} key={content.link} className="link-button">
				<Card.Block
					className="card-button-icon"
					style={{
						backgroundImage: `url(${isHovered ? hoverUrl : iconUrl})`,
					}}
				/>
				<Card.Block>
					<Paragraph>{content.title}</Paragraph>
				</Card.Block>
			</a>
		</Card>
	);
};

export const renderLinkButtonWrapper = (
	linkButtonContentArray: LinkButtonContent[],
) => {
	return linkButtonContentArray.map((content, i) => (
		<LinkButton content={content} index={i} key={content.link} />
	));
};
